import { actions as pageSectionActions } from 'Data/ReduxViewModels/PageSections';
import { Severity } from 'Data/ViewModels/Core/types';
import classNames from 'classnames';
import { isNil } from 'ramda';
import React from 'react';
import { useDispatch } from 'react-redux';
import './Message.scss';
import { MessageLinkTarget } from './MessageLinkTarget';

import reactStringReplace from 'react-string-replace';
import Link from '../Link';
export interface IMessageProps {
  border?: boolean;
  error?: boolean;
  id?: string;
  info?: boolean;
  linkToId?: string;
  message?: string;
  severity?: Severity;
  success?: boolean;
  warning?: boolean;
}

const Message: React.FC<React.PropsWithChildren<IMessageProps>> = ({
  border = true,
  children,
  error = false,
  id,
  info = false,
  linkToId,
  message,
  severity,
  success = false,
  warning = false,
}) => {
  if (id !== undefined && id === linkToId) throw new Error('A message cannot link to itself.');

  const cx = classNames('Message', {
    'Message-border': border,
    'Message-error': error || severity === 'error',
    'Message-info': info || severity === 'info',
    'Message-success': success || severity === 'success',
    'Message-warning': warning || severity === 'warning',
  });

  const child = (
    <>
      {/* Replace all link syntax in message with a Link component */}
      {reactStringReplace(message, /(\[.+?\]\(.+?::.+?\))/g, (messageLink: string, index: number) => {
        const match = /\[(.+?)\]\((.+?)::(.+?)\)/.exec(messageLink)!;
        return (
          <Link key={index} to={`/${match[2]}/${match[3]}`}>
            {match[1]}
          </Link>
        );
      })}
      {children}
    </>
  );
  const dispatch = useDispatch();

  const handleClick = () => {
    const pageSectionId = document.getElementById(`message-link-${linkToId}`)?.closest('.PageSection')?.id;
    if (!pageSectionId) return;
    // Default behaviour continues so the page will move to the anchor href after the section is opened.
    dispatch(pageSectionActions.setCollapsed({ id: pageSectionId, collapsed: false }));
  };

  return isNil(message) && isNil(children) ? null : (
    <span className={cx}>
      {!linkToId && id && (error || severity === 'error') && <MessageLinkTarget id={id} />}
      {linkToId ? (
        <a href={`#message-link-${linkToId}`} onClick={handleClick}>
          {child}
        </a>
      ) : (
        child
      )}
    </span>
  );
};
export { Message };
